module.exports = __webpack_public_path__ + "img/FK.3e6e8e62.svg";